module.exports = __webpack_public_path__ + "img/home_menu_3_selected.d43d3018.png";